import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { ASYNC_CREATE_FUND, ASYNC_EDIT_FUND } from 'store';
import { Row, Col, Form, Card, Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { api } from 'services';
import arrayAppend from 'helpers/array-append';
import Select from 'react-select';
import History from 'components/History';
import FileUploadMultiple from 'components/FileUploadMultiple';
import Currency, {
  EuroCurrency,
  DollarCurrency,
  currencyReverse,
} from 'helpers/Currency';
import MasterPage from 'components/MasterPage';
import swal from '../../../helpers/swal';
import { DashboardOutlined } from '@material-ui/icons';
const FundsForm = ({
  createOrEdit,
  match: {
    params: { id },
  },
}) => {
  const [type, setType] = useState('');
  const [currency, setCurrency] = useState('');
  const [cotacao, setCotacao] = useState('');
  const [company_id, setCompanyId] = useState('');
  const [company_rule_id, setCompanyRuleId] = useState('');
  const [value_expected, setValueExpected] = useState('');
  const [value_real, setValueReal] = useState('');
  const [hasValueReal, setHasValueReal] = useState(false);
  const [description, setDescription] = useState('');
  const [historyComment, setHistoryComment] = useState('');
  const [files, setFiles] = useState([]);
  const [filesComments, setFilesComments] = useState([]);

  const [existingFiles, setExistingFiles] = useState([]);

  const [types, setTypes] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [rules, setRules] = useState([]);
  const [histories, setHistories] = useState([]);
  const [errors, setErrors] = useState([]);
  const [isLoad, setLoad] = useState(false);
  var VendorsArr = [];

  const handleErrors = (errors) => {
    setErrors(errors);
    setLoad(false);
    swal('Ops!', errors, 'error');
  };

  useEffect(() => {
    async function getData() {
      let api_companies = [];

      api.get('fund-types').then(({ data }) => setTypes(data));

      api.get('currencies').then(({ data }) => setCurrencies(data));

      await api.get('companies/rules',{params:{fund_id:id}}).then(({ data }) => {
        api_companies = data;
        setCompanies(data);
      });

      if (id) {
        api.get(`funds/${id}`).then(({ data }) => {
          setType(data.type_id);
          setCurrency(data.currency_id.toString());
          setCompanyId(data.company_id);
          api_companies.forEach((company) => {
            if (company.id === parseInt(data.company_id))
              setRules(company.rules);
          });

          setCompanyRuleId(data.company_rule_id);
          setValueExpected(parseFloat(data.value_expected));
          setCotacao(parseFloat(data.value_cotacao));

          if (!!data.value_real) {
            setValueReal(parseFloat(data.value_real));
            setHasValueReal(true);
          }

          setDescription(data.description);
          setExistingFiles(data.files);
          setHistories(data.histories);
        });
      }
    }
    getData();
  }, [id]);

  const getVendors = () => {
    companies.map((company) => {
      return VendorsArr.push({
        label: company.alias,
        value: company.id,
      });
    });

    VendorsArr.sort((a, b) => {
      return +(a.label > b.label) || +(a.label === b.label) - 1;
    });

    VendorsArr.map((label) => {
      return companies[label.index];
    });
  };

  const findVendors = (value) => {
    let flag;
    VendorsArr.map((v, k) => {
      if (value === v.value) {
        flag = k;
      }
    });
    return flag;
  };

  const { t } = useTranslation();

  getVendors();

  const handleChangeCompany = (e) => {
    api
      .get(`companies/${e.value}/available-rules`)
      .then(({ data }) => setRules(data.rules));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoad(true);

    const formData = new FormData();

    if (!!id) formData.append('id', id);
    formData.append('type_id', type);
    formData.append('currency_id', currency);
    formData.append('company_id', company_id);
    formData.append('company_rule_id', company_rule_id);
    formData.append(
      'value_expected',
      !!id ? value_expected : currencyReverse(value_expected)
    );
    if (!!value_real)
      formData.append('value_real', currencyReverse(value_real));
    formData.append('description', description);
    formData.append('history_comment', historyComment);

    if (currency !== '1') {
      formData.append('value_cotacao', cotacao ? currencyReverse(cotacao) : 0);
    }

    arrayAppend(formData, 'file', files);
    arrayAppend(formData, 'filescomments', filesComments);

    createOrEdit(formData, handleErrors);
  };

  const currencyMask = (
    onChangeParam,
    valueParam,
    disabledParam,
    forceCurrency = null
  ) => {
    let mask;
    let currency_aux = forceCurrency ? forceCurrency : currency;
    switch (currency_aux) {
      case '1':
        mask = (
          <Currency
            value={valueParam}
            onChange={onChangeParam}
            disabled={disabledParam || currency.length === 0}
            required={true}
          />
        );
        break;
      case '2':
        mask = (
          <DollarCurrency
            value={valueParam}
            onChange={onChangeParam}
            disabled={disabledParam || currency.length === 0}
            required={true}
          />
        );
        break;
      case '3':
        mask = (
          <EuroCurrency
            value={valueParam}
            onChange={onChangeParam}
            disabled={disabledParam || currency.length === 0}
            required={true}
          />
        );
        break;
      default:
        mask = (
          <Form.Control
            as="input"
            value={valueParam}
            onChange={onChangeParam}
            disabled={currency.length === 0}
            required={true}
          />
        );
    }
    return mask;
  };

  const realOrExpectedValue = (flag) => {
    let value;
    if (flag === true) {
      value = value_expected;
    } else {
      value = value_real;
    }
    return value;
  };

  const readOnlySelect = !!id
    ? {
      style: {
        background: '#eee',
        pointerEvents: 'none',
        touchAction: 'none',
      },
      tabIndex: -1,
    }
    : null;

  return (
    <Form onSubmit={handleSubmit}>
      <Card.Body className="shadow bg-white rounded mt-3 mb-3">
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">{t('title:create fund')}</h4>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Row>
              <Col md="4">
                <Form.Group>
                  <Form.Label>{t('label:company')}</Form.Label>
                  <Select
                    key={company_id}
                    name="vendor"
                    mode="input"
                    options={VendorsArr}
                    placeholder={t('label:select')}
                    defaultValue={VendorsArr[findVendors(company_id)]}
                    required
                    isDisabled={!!id}
                    onChange={(e) => {
                      setCompanyRuleId('');
                      companies.forEach((company) => {
                        if (company.id === parseInt(e.value))
                          setRules(company.rules);
                      });
                      setCompanyId(e.value);
                      handleChangeCompany(e);
                    }}
                    noOptionsMessage={() =>
                      VendorsArr.length === 0
                        ? t('label:loading')
                        : 'No Options'
                    }
                  />
                </Form.Group>
              </Col>
              <Col md={currency != 1 && currency !== '' ? '2' : '4'}>
                <Form.Group>
                  <Form.Label>{t('label:currency')}</Form.Label>
                  <Form.Control
                    as="select"
                    value={currency}
                    onChange={(e) => {
                      if (type !== '') {
                        let old = currency !== '' ? currency : '1';
                        let now = e.target.value;
                        setType(parseInt(type) + (now - old) * 4);
                      }
                      setCurrency(e.target.value);
                    }}
                    required
                    {...readOnlySelect}
                  >
                    <option disabled value="">
                      {t('label:select')}
                    </option>
                    {currencies.map((currency, k) => (
                      <option key={k} value={currency.id}>
                        {t(`label:${currency.name}`)}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              {currency !== '1' && currency !== '' ? (
                <Col md="2">
                  <Form.Group>
                    <Form.Label>Valor da Cotação</Form.Label>
                    {currencyMask(
                      (e) => setCotacao(e.target.value),
                      cotacao,
                      !!id,
                      '1'
                    )}
                    <Form.Text className="text-muted">
                      {currency === '2'
                        ? '$ 1.00'
                        : currency === '3'
                          ? '€ 1,00'
                          : ''}
                      {' = '}
                      {cotacao
                        ? 'R$ ' +
                        parseFloat(currencyReverse(cotacao))
                          .toFixed(2)
                          .replace('.', ',')
                        : 'R$ 0,00'}
                    </Form.Text>
                  </Form.Group>
                </Col>
              ) : (
                ''
              )}
              <Col md="4">
                <Form.Group>
                  <Form.Label>{t('label:fund type')}</Form.Label>
                  <Form.Control
                    as="select"
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                    required
                    {...readOnlySelect}
                  >
                    <option disabled value="">
                      {t('label:select')}
                    </option>
                    {types
                      .filter((type) =>
                        currency.length > 0
                          ? type.currency_id == currency
                          : type
                      )
                      .slice(0, 4)
                      .map((type, k) => (
                        <option key={k} value={type.id}>
                          {t(`label:${type.name}`)}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:period')}</Form.Label>
                  <Form.Control
                    as="select"
                    value={company_rule_id}
                    onChange={(e) => setCompanyRuleId(e.target.value)}
                    disabled={rules.length === 0}
                    required
                    {...readOnlySelect}
                  >
                    <option disabled value="">
                      {t('label:select')}
                    </option>
                    {rules.filter((f) => id ? f : f.deleted_at == null).map((rule, k) => (
                      <option key={k} value={rule.id}>
                        {rule.period.type.name} {rule.period.position}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:expected amount')}</Form.Label>
                  {currencyMask(
                    (e) => setValueExpected(e.target.value),
                    value_expected,
                    !!id
                  )}
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:real amount')}</Form.Label>
                  {currencyMask(
                    (e) => setValueReal(e.target.value),
                    value_real,
                    !!id && !!hasValueReal
                  )}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:brief description')}</Form.Label>
                  <Form.Control
                    as="textarea"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    required
                    disabled={!!id && !!hasValueReal}
                  />
                </Form.Group>
              </Col>
            </Row>
            <FileUploadMultiple
              files={files}
              setFiles={setFiles}
              filesComments={filesComments}
              setFilesComments={setFilesComments}
              existingFiles={existingFiles}
              disabled={!!id && !!hasValueReal}
            />
            <Form.Group>
              <Form.Label>{t('label:comment')}</Form.Label>
              <Form.Control
                as="textarea"
                value={historyComment}
                onChange={(e) => setHistoryComment(e.target.value)}
                disabled={!!id && !!hasValueReal}
              />
            </Form.Group>
            {isLoad ? (
              <Row className="col">
                <Spinner animation="border" style={{ color: '#e05c17' }} />
                <h6 className="m-2">Salvando...</h6>
              </Row>
            ) : (
                <Button
                  size="sm"
                  variant="dark"
                  type="submit"
                  disabled={!!id && !!hasValueReal}
                >
                  {t('label:save')}
                </Button>
              )}
          </Col>
        </Row>
        <History histories={histories} />
      </Card.Body>
    </Form>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  createOrEdit: (payload, handleError) => {
    if (payload.has('id'))
      dispatch({ type: ASYNC_EDIT_FUND, payload, handleError });
    else dispatch({ type: ASYNC_CREATE_FUND, payload, handleError });
  },
});

const reduxConnect = connect(mapStateToProps, mapDispatchToProps)(FundsForm);

export default MasterPage(reduxConnect);
